<template>
    <div class="center-page">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="上架中" name="1"></el-tab-pane>
            <el-tab-pane label="已下架" name="2"></el-tab-pane>
            <el-tab-pane label="审核中" name="3"></el-tab-pane>
            <el-tab-pane label="已通过" name="4"></el-tab-pane>
            <el-tab-pane label="未通过" name="5"></el-tab-pane>
        </el-tabs>
        <div class="list-content" v-loading="loading">
            <div class="list-head">
                <div class="f-14 color-grays"></div>
                <el-button type="primary" size="mini" @click="$router.push({path:'/center/addLine'})">添加路线+</el-button>
            </div>
            <div class="list-item" v-for="(item,index) in list" :key="index">
                <img class="list-item-img" :src="`/api/v1/file/${item.cover}`" alt="">
                <div>
                    <div class="mb-10 item-title">
                        <div class="f-16 fw-b ">{{item.title}}</div>
                    </div>
                    <div class="f-14 color-grays">游玩天数： {{item.play_time}}</div>
                    <div class="btn-content">
                        <el-button v-if="item.is_shelves===1" type="warning" @click="lineShelvess(item.id, 1)" size="mini">下架</el-button>
                        <el-button v-if="item.is_shelves===2" type="success" @click="lineShelvess(item.id, 2)" size="mini">上架</el-button>
                        <el-button type="warning" size="mini" @click="toEdit(item)">编辑</el-button>
                        <el-button type="success" size="mini" @click="toDetail(item)">查看详情</el-button>
                        <el-button type="success" size="mini" @click="calendarShow(item)">日历管理</el-button>
                    </div>
                </div>
                <div class="f-16 ml-a">价格：<span class="color-red f-22">{{+item.price|parseMoney}}</span></div>
            </div>
            <el-alert v-if="list.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
        <el-dialog :visible.sync="showCalendar" title="日历管理" width="550px">
            <el-form label-width="120px" label-position="right">
                <el-form-item label="导入日历：">
                    <el-input style="width: 240px;"></el-input>
                </el-form-item>
                <el-form-item label="导出日历：">
                    <el-link type="primary" :underline="false">导出</el-link>
                </el-form-item>
                <el-form-item label="日历管理：">
                    <Calendar v-loading="cloading" :item="calendarData" @change="handleCalendarChange" @select="handleCalendarSelect"></Calendar>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="engineDriverAddTourist">设为不可用</el-button>
                    <el-button type="success" @click="engineDriverDelsTourist">设为可用</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import LineCard from "../../components/LineCard";
    import Calendar from '../../components/Calendar'
    export default {
        name: "lineManage",
        components:{LineCard, Calendar},
        data() {
            return {
                activeName: '1',
                list: [],
                loading: false,
                cloading: false,
                showCalendar: false,
                year: '',
                month: '',
                tourist_id: '',
                calendarData: {},
                selectCalendarData: {}
            }
        },
        created() {
            this.touristIndex();
        },
        methods: {
            handleClick() {
                this.touristIndex();
            },
            async touristIndex(){
                let param = {};
                if(this.activeName<=2){
                    param.is_shelves = this.activeName;
                }else{
                    param.is_state = this.activeName - 3;
                }
                let [e, data] = await this.$api.touristIndexApi(param)
                this.list = data.result.basic;
            },
            async lineDelect(id){

            },
            toEdit(item){
                this.$store.commit('updateParamsData', item);
                this.$router.push({path: '/center/addLine', query:{id: item.id}})
            },
            toDetail(item){
                this.$router.push({path: '/lineDetail', query:{id: item.id}})
            },
            async calendarShow(item){
                let now = new Date();
                this.year = now.getFullYear();
                this.month = now.getMonth() + 1;
                this.tourist_id = item.id
                this.showCalendar = true;
                this.calendarTourist();
            },
            async calendarTourist(){
                this.cloading = true;
                let [e, data] = await this.$api.calendarTouristApi({
                    year: this.year,
                    month: this.month,
                    type: 1,
                    tourist_id: this.tourist_id
                })
                this.cloading = false;
                this.calendarData = data.result;
            },
            handleCalendarChange({year, month}){
                this.year = year;
                this.month = month;
                this.calendarTourist();
            },
            handleCalendarSelect(data){
                this.selectCalendarData = data
            },
            async engineDriverAddTourist(){
                let {year, month, day} = this.selectCalendarData;
                let [e, data] = await this.$api.engineDriverAddTouristApi({
                    time: `${year}-${month}-${day}`,
                    tourist_id: this.tourist_id
                })
                if(data.status){
                    this.$message.success('设置成功！');
                    this.calendarTourist()
                }else {
                    this.$message.warning(data.msg)
                }
            },
            async engineDriverDelsTourist(){
                let {year, month, day} = this.selectCalendarData;
                let [e, data] = await this.$api.engineDriverDelsTouristApi({
                    time: `${year}-${month}-${day}`,
                    tourist_id: this.tourist_id
                })
                if(data.status){
                    this.$message.success('设置成功！');
                    this.calendarTourist()
                }else {
                    this.$message.warning(data.msg)
                }
            },
            async lineShelvess(id, is_shelves){
                let [e, data] = await this.$api.lineShelvessApi({id, is_shelves})
                if(data.status){
                    this.touristIndex();
                }else{

                }
            }
        },
    }
</script>

<style scoped lang="less">
    .list-content {
        width: 100%;

        .list-head {
            width: 100%;
            height: 54px;
            border-bottom: 1px solid #e2e2e2;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
        }

        .list-item {
            width: 100%;
            height: 140px;
            padding: 20px;
            box-sizing: border-box;
            border-bottom: 1px solid #e2e2e2;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .list-item-img {
                width: 100px;
                height: 100px;
                object-fit: cover;
                margin-right: 20px;
                border-radius: 8px;
            }

            .item-title {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .btn-content {
                margin-top: 10px;
            }
        }
    }
</style>
